import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import TranslateRoundedIcon from "@mui/icons-material/TranslateRounded";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { ANALYTICS_IDS } from "../../../constants/analytics";
import { useGlobalLinks, useRegionSelectVisibility
} from "../../../services/app-state";
import { useAssessmentState } from "../../../services/assessment-state";
import { getAcfPostUrl } from "../../../utils";
import { Action, Actions } from "./styled";


export const LocationLanguageButtons: FC<{ showRegion?: boolean; showLanguages?: boolean; hideLanguagesDesktop?: boolean; suburbCondition?: boolean }> = ({
    showRegion,
    showLanguages,
    hideLanguagesDesktop,
    suburbCondition
}) => {
    const [, { getGlobalLink }] = useGlobalLinks();
    const languagesPage = getGlobalLink("languages_page");
    const [, { setRegionSelectVisibility }] = useRegionSelectVisibility();
    const { state } = useAssessmentState();

    const handleAnchorClick = () => {
        setRegionSelectVisibility(true);
    };

    return (
        <div className={suburbCondition?"hide-for-desktop":""}>
            <Actions>
                <Action highlight>
                    <LocationOnRoundedIcon />
                    {showRegion && state.suburb != null && (
                        <span style={{ color: "white" }}>{state.newsuburbname}</span>
                    )}

                    <a 
                        data-analytics-id={ANALYTICS_IDS.selectSuburbCta} 
                        onClick={handleAnchorClick} 
                        rel="noreferrer" > 
                        {state.suburb ? "Change suburb" : "Set your suburb"}
                    </a>

                </Action>
                {showLanguages && (
                    <div className={hideLanguagesDesktop ? "hide-for-desktop" : ""}>
                        <Action>
                            <TranslateRoundedIcon />
                            <Link to={getAcfPostUrl(languagesPage)}>{languagesPage.post_title}</Link>
                        </Action>
                    </div>
                )}      
            </Actions>    
        </div>    
    );
};
